import { render } from "./Proportionevents.vue?vue&type=template&id=7bf9498d"
import script from "./Proportionevents.vue?vue&type=script&lang=js"
export * from "./Proportionevents.vue?vue&type=script&lang=js"

import "./Proportionevents.vue?vue&type=style&index=0&id=7bf9498d&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__